import { Tab } from "@headlessui/react";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const SettingsTabNames = ({ tabName }) => {
  return (
    <Tab
      className={({ selected }) =>
        classNames(
          "w-full py-3 leading-5 font-medium text-black uppercase px-10 border border-gray-800 shadow rounded-lg",
          selected ? "bg-gray-50" : "text-black"
        )
      }
    >
      {tabName}
    </Tab>
  );
};

export default SettingsTabNames;
